<template lang="html">
  <div class="d-flex flex-column align-center ma-auto">
    <v-progress-linear height="8" class="mb-2" color="primary" style="max-width: 48px" :model-value="'100'" />

    <div style="position: relative">
      <v-progress-circular size="96" width="8" color="primary" :model-value="'100'" />

      <v-progress-circular
        indeterminate
        size="96"
        width="8"
        color="primary"
        style="position: absolute; top: 0; left: 0"
      />
    </div>
  </div>
</template>
